import * as types from './templateTypes';
import allTemplates from '../../templates/data/all-templates.json';
import categories from '../../templates/data/categories.json';
import { addToScene, addPage } from './index';
import store from '../store';

// Modal Açma/Kapama
export const openTemplateLibrary = () => ({
    type: types.OPEN_TEMPLATE_LIBRARY
});

export const closeTemplateLibrary = () => ({
    type: types.CLOSE_TEMPLATE_LIBRARY
});

// Kategori Seçimi
export const selectCategory = (categoryId) => ({
    type: types.SELECT_CATEGORY,
    payload: categoryId
});

// Arama
export const searchTemplates = (query) => ({
    type: types.SEARCH_TEMPLATES,
    payload: query
});

export const clearSearch = () => ({
    type: types.CLEAR_SEARCH
});

// View Mode
export const setViewMode = (mode) => ({
    type: types.SET_VIEW_MODE,
    payload: mode
});

// Template ve Kategori Yükleme
export const loadTemplates = () => (dispatch) => {
    dispatch({
        type: types.LOAD_TEMPLATES_SUCCESS,
        payload: allTemplates
    });
};

export const loadCategories = () => (dispatch) => {
    dispatch({
        type: types.LOAD_CATEGORIES_SUCCESS,
        payload: categories
    });
};

// Template Uygulama - Editor'a entegrasyon
// Template Uygulama - Editor'a entegrasyon
export const applyTemplateToDocument = (template) => async (dispatch, getState) => {
    console.log('🎨 Template uygulanıyor:', template);
    
    dispatch({
        type: types.APPLY_TEMPLATE,
        payload: template
    });
    
    // Aktif sayfa bilgisini al
    const state = getState();
    const pages = state.appReducers.Pages;
    
    if (!template.elements && !template.pages) {
        console.warn('⚠️ Bu template henüz hazır değil:', template.name);
        alert(`⚠️ "${template.name}" template'i henüz hazır değil.`);
        return;
    }
    
    // Multi-page veya single-page template'i element listesine düzleştir
    let allElements = [];
    
    if (template.pages && template.pages.length > 0) {
        // Multi-page template
        template.pages.forEach((page, pageIndex) => {
            const pageId = pages && pages.length > pageIndex 
                ? pages[pageIndex].id 
                : (pages && pages.length > 0 ? pages[0].id : 1);
            
            // İlk sayfa dışındakiler için yeni sayfa oluştur
            if (pageIndex > 0 && (!pages || pages.length <= pageIndex)) {
                dispatch(addPage(
                    Date.now() + pageIndex,
                    template.pageSettings?.width || 595,
                    template.pageSettings?.height || 842
                ));
            }
            
            (page.elements || []).forEach(el => {
                allElements.push({ ...el, _pageId: pageId, _pageIndex: pageIndex });
            });
        });
    } else if (template.elements && template.elements.length > 0) {
        // Single-page template
        const currentPageId = pages && pages.length > 0 ? pages[0].id : 1;
        template.elements.forEach(el => {
            allElements.push({ ...el, _pageId: currentPageId, _pageIndex: 0 });
        });
    }
    
    if (allElements.length === 0) {
        alert(`⚠️ "${template.name}" template'inde element bulunamadı.`);
        return;
    }
    
    // ✅ TEMPLATE DECORATION PRE-FETCH
    // Template'te Picture element'lerinin JpgFileName'leri /template-assets/ altındaki PNG'leri
    // işaret ediyor. Bunları blob'a çevirip user'ın upload ettiği dosya gibi sisteme dahil et.
    // Sonraki Save/Open/Export akışları hiç değişmeden standart yolla çalışır.
    const pictureFilenames = [...new Set(
        allElements
            .filter(el => (el.type || '').toLowerCase() === 'picture')
            .map(el => el.properties?.JpgFileName)
            .filter(Boolean)
    )];
    
    const blobUrlMap = {};
    if (pictureFilenames.length > 0) {
        console.log(`📥 Fetching ${pictureFilenames.length} template decoration(s)...`);
        await Promise.all(pictureFilenames.map(async (fn) => {
            try {
                const response = await fetch(`/template-assets/${fn}`);
                if (!response.ok) {
                    console.warn(`⚠️ Template decoration not found: ${fn} (${response.status})`);
                    return;
                }
                const blob = await response.blob();
                blobUrlMap[fn] = URL.createObjectURL(blob);
            } catch (e) {
                console.warn(`⚠️ Failed to load decoration ${fn}:`, e.message);
            }
        }));
    }
    
    let elementCounter = Date.now();
    
    allElements.forEach((element, index) => {
        const uniqueId = elementCounter + index;
        const objName = `element_${uniqueId}`;
        const objZindex = uniqueId * 100;
        const pageId = element._pageId;
        
        // Element tipini belirle
        let elementType = element.type;
        const lowerType = element.type.toLowerCase();
        
        // Tip normalizasyonu
        const typeMap = {
            'text': 'TextBox', 'textbox': 'TextBox',
            'table': 'Table', 'dynamictable': 'Table',
            'barcode': 'Barcode', 'qrcode': 'Barcode',
            'rectangle': 'Rectangle', 'lines': 'Lines',
            'ellipse': 'Ellipse', 'picture': 'Picture',
            'word': 'Word', 'signature': 'Signature',
            'shape': 'Shape'
        };
        elementType = typeMap[lowerType] || (element.type.charAt(0).toUpperCase() + element.type.slice(1));
        
        // Koordinat ve boyut
        const x = element.properties?.location?.x ?? element.properties?.left ?? 0;
        const y = element.properties?.location?.y ?? element.properties?.top ?? 0;
        const width = element.properties?.size?.width ?? element.properties?.width ?? 100;
        const height = element.properties?.size?.height ?? element.properties?.height ?? 30;
        
 // Tüm element tipleri için gerekli olabilecek default property'ler
const baseProps = {
    Text: '',
    Font: 'Arial',
    FontFamily: 'Arial',
    FontSize: 12,
    Bold: false,
    Italic: false,
    Color: '#000000',
    TextAlign: 'Left',
    DataType: 'Text',
    DataSource: '',
    JpgFileName: '',
    JpgBlob: '',
    JpgPath: '',
    CertFileName: '',
    CertBlob: '',
    CertPath: '',
    Password: '',
    ContentState: '',
    BorderColor: '#000000',
    BorderWidth: 1,
    BorderStyle: 'Solid',
    Fill: false,
    FillColor: '#FFFFFF',
    Direction: 'Horizontal',
    Mline: false,
    colors: element.properties?.colors || {
        color: element.properties?.Color || '#000000',
        backgroundColor: element.properties?.FillColor || '#FFFFFF'
    }
};

const elementObject = {
    type: elementType,
    content: element.content || element.properties?.Text || '',
    jpg: "",
    ObjName: objName,
    PageId: pageId,
    id: objName,
    properties: {
        ...baseProps,
        ...element.properties,
        // ✅ Z-INDEX FIX: Template'in tasarladığı Zindex (örn: PNG=0, Rectangle=5, Text=200)
        // korunmalı ki layering canvas'ta da PDF'teki gibi görünsün.
        // Element'in kendi Zindex'i varsa onu kullan, yoksa fallback hesapla.
        Zindex: (element.properties && element.properties.Zindex !== undefined && element.properties.Zindex !== null)
            ? element.properties.Zindex
            : objZindex,
        location: { x, y, fx: x, fy: y },
        size: { width, height },
        colors: element.properties?.colors || baseProps.colors
    }
};


        // Element tipine göre özel özellikler
        switch(lowerType) {
            case 'text':
            case 'textbox':
                elementObject.properties = {
                    ...elementObject.properties,
                    Font: element.properties.Font || 'Arial',
                    FontFamily: element.properties.FontFamily || 'Arial',
                    FontSize: element.properties.FontSize || 12,
                    Bold: element.properties.Bold || false,
                    Italic: element.properties.Italic || false,
                    Underline: element.properties.Underline || false,
                    Color: element.properties.Color || '#000000',
                    TextAlign: element.properties.TextAlign || 'Left',
                    DataType: element.properties.DataType || 'Text',
                    DataSource: element.properties.DataSource || '',
                    Mline: element.properties.Mline || false,
                    Format: element.properties.Format || '',
                    colors: {
                        color: element.properties.Color || '#000000',
                        backgroundColor: element.properties.backgroundColor || 'transparent'
                    }
                };
                break;
                
            case 'rectangle':
                elementObject.properties = {
                    ...elementObject.properties,
                    Fill: element.properties.Fill !== undefined ? element.properties.Fill : true,
                    FillColor: element.properties.FillColor || '#FFFFFF',
                    BorderColor: element.properties.BorderColor || '#000000',
                    BorderWidth: element.properties.BorderWidth ?? 1,
                    colors: {
                        color: element.properties.BorderColor || '#000000',
                        backgroundColor: element.properties.FillColor || '#FFFFFF'
                    }
                };
                break;
                
            case 'lines':
                elementObject.properties = {
                    ...elementObject.properties,
                    Color: element.properties.Color || '#000000',
                    LineWidth: element.properties.LineWidth || 1,
                    Values: element.properties.Values || `${x} ${y} ${x + width} ${y}`,
                    colors: {
                        color: element.properties.Color || '#000000'
                    }
                };
                break;
                
            case 'ellipse':
                elementObject.properties = {
                    ...elementObject.properties,
                    Fill: element.properties.Fill !== undefined ? element.properties.Fill : true,
                    FillColor: element.properties.FillColor || '#FFFFFF',
                    BorderColor: element.properties.BorderColor || '#000000',
                    BorderWidth: element.properties.BorderWidth ?? 1,
                    colors: {
                        color: element.properties.BorderColor || '#000000',
                        backgroundColor: element.properties.FillColor || '#FFFFFF'
                    }
                };
                break;
                
            case 'word':
                elementObject.properties = {
                    ...elementObject.properties,
                    blocks: element.properties.blocks || [],
                    Font: element.properties.Font || 'Arial',
                    FontFamily: element.properties.FontFamily || 'Arial'
                };
                break;
                
case 'signature':
    elementObject.properties = {
        ...elementObject.properties,
        Text: '',              // ← BUNU EKLE
        JpgFileName: '',       // ← BUNU EKLE
        JpgBlob: '',           // ← BUNU EKLE
        JpgPath: '',           // ← BUNU EKLE
        CertFileName: '',      // ← BUNU EKLE
        CertBlob: '',          // ← BUNU EKLE
        CertPath: '',          // ← BUNU EKLE
        Password: '',          // ← BUNU EKLE
        SignatureData: element.properties.SignatureData || '',
        Placeholder: element.properties.Placeholder || 'İmza alanı',
        colors: {
            color: '#000000',
            backgroundColor: '#FFFFFF'
        }
    };
    break;
                
            case 'table':
            case 'dynamictable':
                elementObject.type = 'Table';
                elementObject.properties = {
                    ...elementObject.properties,
                    BorderColor: element.properties.BorderColor || '#000000',
                    BorderWidth: element.properties.BorderWidth || 1,
                    Fill: element.properties.Fill || false,
                    FillColor: element.properties.FillColor || '#ffffff',
                    HasHeader: element.properties.HasHeader !== undefined ? element.properties.HasHeader : true,
                    HeaderHeight: element.properties.HeaderHeight || 30,
                    RowHeight: element.properties.RowHeight || 25,
                    HeaderBgColor: element.properties.HeaderBgColor || '#333333',
                    HeaderFontColor: element.properties.HeaderFontColor || '#FFFFFF',
                    AltRowBgColor: element.properties.AltRowBgColor || '#f5f5f5',
                    ZebraStripe: element.properties.ZebraStripe || true,
                    AlternateColor: element.properties.AltRowBgColor || '#f5f5f5',
                    Mode: element.properties.Mode || 'Dynamic',
                    TableData: Array.isArray(element.properties.TableData) ? element.properties.TableData : [],
                    DataSource: element.properties.DataSource || ''
                };
                break;
                
            case 'barcode':
            case 'qrcode':
                let barcodeType = element.properties.BarcodeType || 'Code128';
                if (lowerType === 'qrcode' || barcodeType.toLowerCase() === 'qr') {
                    barcodeType = 'QR';
                }
                elementObject.type = 'Barcode';
                elementObject.properties = {
                    ...elementObject.properties,
                    BarcodeType: barcodeType,
                    ShowText: element.properties.ShowText !== undefined ? element.properties.ShowText : true,
                    BarcodeValue: element.content || element.properties.BarcodeValue || '123456789',
                    DataSource: element.properties.DataSource || '',
                    colors: {
                        color: element.properties.Color || '#000000',
                        backgroundColor: '#FFFFFF'
                    }
                };
                break;
                
            case 'picture':
                {
                    // ✅ Template decoration PNG: pre-fetch blob URL'si kullan (varsa)
                    // Sonraki Save standart akışı: fetch(JpgBlob) -> FormData -> backend user klasörü
                    const fn = element.properties.JpgFileName || '';
                    const blobUrl = blobUrlMap[fn] || '';
                    elementObject.properties = {
                        ...elementObject.properties,
                        JpgFileName: fn,
                        JpgBlob: blobUrl,    // Save akışı bunu upload eder
                        JpgPath: '',         // Open'da backend URL set edilecek (standart davranış)
                        ImageSource: element.properties.ImageSource || '',
                        MaintainAspectRatio: element.properties.MaintainAspectRatio !== undefined ? element.properties.MaintainAspectRatio : true
                    };
                }
                break;
                
            case 'shape':
                elementObject.properties = {
                    ...elementObject.properties,
                    ShapeType: element.properties.ShapeType || 'Rectangle',
                    BorderColor: element.properties.BorderColor || '#000000',
                    BorderWidth: element.properties.BorderWidth || 1,
                    Fill: element.properties.Fill || true,
                    FillColor: element.properties.FillColor || '#ffffff'
                };
                break;
                
            default:
                console.warn('⚠️ Bilinmeyen element tipi:', element.type);
        }
        
        // Element'i canvas'a ekle
        dispatch(addToScene(objName, elementObject));
    });
    
    // Modal'ı kapat
    dispatch(closeTemplateLibrary());
    
    // Başarı mesajı
    const pageCount = template.pages ? template.pages.length : 1;
    const elemCount = allElements.length;
    console.log(`✅ ${template.name} — ${elemCount} element, ${pageCount} sayfa eklendi!`);
    alert(`✅ ${template.name} başarıyla eklendi!\n${elemCount} element, ${pageCount} sayfa.`);
};
